import { render, staticRenderFns } from "./shipperDetail.vue?vue&type=template&id=0239f1da&"
import script from "./shipperDetail.vue?vue&type=script&lang=js&"
export * from "./shipperDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports